import Vue from 'vue';

import {date} from "./date";

Vue.prototype.$date = date;